import { AppBar, IconButton, Toolbar, Tooltip } from "@mui/material";
import { Logo } from "../Logo/Logo";
import { ListingsDropdown } from "./components/ListingsDropdown";
import classes from "./DesktopHeader.module.scss";
import { IDesktopHeader, IListing } from "../../interfaces";
import { useState } from "react";
import { LogoutIcon } from "../../../assets/icons/LogoutIcon";
import {
  LOGOUT_USER_REQUEST,
  SET_SELECTED_LISTINGS,
} from "../../../redux/actions";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import { Typography } from "@/shared/ui/typography";
import { PERFORMANCE_PAGE_ACTIONS_TO_DISPATCH } from "@/utils/constants/performancePageActions";

export const DesktopHeader = ({ listings, logo, userName }: IDesktopHeader) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch({
      type: LOGOUT_USER_REQUEST,
      payload: { navigate },
    });
  };

  const onSelect = (listings: IListing[]) => {
    handleClose();
    const listingIDs = listings?.map((listing) => listing.property_id);

    dispatch({
      type: SET_SELECTED_LISTINGS,
      payload: { listings },
    });
    PERFORMANCE_PAGE_ACTIONS_TO_DISPATCH.forEach((action) => {
      dispatch({
        type: action,
        payload: listingIDs,
      });
    });
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const noListings = listings === null || listings.length === 0;

  return (
    <AppBar className={classes.headerContainer} position="fixed">
      <div className={classes.actionsContainer}>
        <Toolbar>
          <Logo className={classes.logo} mobile={false} src={logo} />
        </Toolbar>
      </div>
      <div className={classes.actionsContainer}>
        {noListings ? (
          <div className={classes.noListings}>
            <Typography variant="text-md" weight="medium">
              No listings available
            </Typography>
          </div>
        ) : (
          <ListingsDropdown
            listings={listings}
            onSelect={onSelect}
            anchorEl={anchorEl}
            handleClick={handleClick}
            handleClose={handleClose}
          />
        )}
        <p className={classes.userData}>{userName}</p>
        <Tooltip
          arrow
          title="Logout"
          classes={{ tooltip: classes.tooltip, arrow: classes.tooltipArrow }}
        >
          <IconButton
            color="inherit"
            aria-label="logout"
            onClick={handleLogout}
            edge="end"
          >
            <LogoutIcon />
          </IconButton>
        </Tooltip>
      </div>
    </AppBar>
  );
};
